import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { FieldComponent } from './field.component';
import { inputValidation } from '@core_n/common/input-validation';

@Component({
  selector: 'app-field-number',
  template: ``,
})

export class FieldNumberComponent extends FieldComponent implements OnInit {
  @Input() MaxNumsAfterDot: number = 0;
  @Input() MaxLength: number;

  constructor() {
    super();
  }

  ngOnInit() {
  }
}
